const base = require('kiosk/users');
Vue.component('spark-kiosk-users', {
  mixins: [base],
  data() {
    return {
      users: [],
    };
  },
  created() {
    self = this;
    Bus.$on('sparkHashChanged', function (hash, parameters) {
        if (hash == 'users') {
            self.loadUsers();
        }
    });
  },
  methods: {
    loadUsers() {
      axios
        .get('/api/admin/users/')
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  template: /*html*/ `
      <div class="kiosk-users-table">
        <div class="table-responsive">
          <table class="table table-valign-middle mb-0">
            <thead>
              <th>{{__('ID')}}</th>
              <th>{{__('Name')}}</th>
              <th>{{__('Hotels')}}</th>
              <th>{{__('Groups')}}</th>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td>
                  <div class="btn-table-align">
                    {{ user.id }}
                  </div>
                </td>
                <td>
                  <div class="btn-table-align">
                    {{ user.name }}
                  </div>
                </td>
                <td>
                  <div class="btn-table-align">
                    <span>
                      {{ user.teams.length }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="btn-table-align">
                    <span>
                      {{ user.groups.map(group => group.name).join(",") }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    `,
});
